'use client';

import { useState, useEffect } from 'react';
import GalleryCardComponent from '../gallery-card/gallery-card.component';
import ContentCardComponent, {
  ParentComponent,
} from '../content-card/content-card.component';

import styles from './carousel.component.module.less';
import { CarouselComponent as Carousel } from '@vaad1st/component.organism.carousel';
import TableCard from '../table-card/table-card.component';

function renderCardComponent(
  cardProps: any,
  cardType: 'content-card' | 'destination-card' | 'table-card',
  itemIndex: number = 0
) {
  switch (cardType) {
    case 'destination-card':
      return (
        <GalleryCardComponent
          key={`Carousel--child--gcc--${itemIndex}`}
          {...cardProps}
        />
      );
    case 'table-card':
      return (
        <TableCard key={`Carousel--child--tcc--${itemIndex}`} {...cardProps} />
      );

    case 'content-card':
      return (
        <ContentCardComponent
          key={`Carousel--child--ccc--${itemIndex}`}
          parentComponent={ParentComponent.Carousel}
          {...cardProps}
        />
      );
    default:
      return null;
  }
}

export default function CarouselComponent(props: any) {
  const propsCopy = { ...props };
  propsCopy.children = []; // Clear out children to us correct components
  // Invert the AEM flag and backlog renaming it.
  propsCopy.extendedXlLayout = props.extendedXlLayout === false ? true : false;

  const children = props.children
    .map((child: any, index: number) => {
      if (child?.cardType) {
        return renderCardComponent(child, child.cardType, index);
      } else {
        if (child) {
          const resourceType = child.props['sling:resourceType'];
          const componentType = resourceType.split('/').pop();
          return renderCardComponent(child.props, componentType, index);
        } else {
          return null;
        }
      }
    })
    .filter((c: any) => c !== null);

  propsCopy.children = children;

  // Trigger resize event once after the final render
  useEffect(() => {
    if (children.length > 0) {
      window.dispatchEvent(new Event('resize'));
    }
  }, [children]);

  return (
    <div className={styles.carousel}>
      <Carousel {...propsCopy} />
    </div>
  );
}
